// extracted by mini-css-extract-plugin
export default {"chat_page":"Chat_chat_page__cXF3I"};